import { Container, Text, TextStyle } from 'pixi.js';
import gsap from 'gsap';

/**
 * Floating text — "×7", "MISS ↓", "SHIELD!" — bobs up and fades out.
 */
export function spawnFloatText(
  parent: Container,
  x: number,
  y: number,
  text: string,
  colorHex: number
): void {
  const t = new Text({
    text,
    style: new TextStyle({
      fontFamily: 'Bungee, Impact',
      fontSize: 18,
      fill: colorHex,
      dropShadow: { color: 0x000000, alpha: 0.6, blur: 0, distance: 2 },
    }),
  });
  t.anchor.set(0.5);
  t.x = x;
  t.y = y;
  t.alpha = 0;
  t.scale.set(0.8);
  parent.addChild(t);

  const tl = gsap.timeline({ onComplete: () => t.destroy() });
  tl.to(t, { alpha: 1, duration: 0.18, ease: 'power2.out' }, 0);
  tl.to(t.scale, { x: 1.1, y: 1.1, duration: 0.18, ease: 'power2.out' }, 0);
  tl.to(t, { y: y - 30, alpha: 0, duration: 0.7, ease: 'power2.out' }, 0.18);
  tl.to(t.scale, { x: 1, y: 1, duration: 0.7 }, 0.18);
}
